// @ts-nocheck
import { setCookie, deleteCookie } from 'utils/cookies/index';
import type { AuthResult } from 'commons/types/authTypes';
import { getAppSettings, isNonNoodleInstance } from 'utils/privateLabel/index';
import { CHROME_COOKIE_MAX_AGE } from 'commons/constants';
import { GlobalPartner } from 'commons/types/partnerInstanceTypes';
import { baseUrl } from '../../settings';

export const setPrivateInstanceCookies = (expiresIn: number, globalPartner?: GlobalPartner) => {
  const appSettings = getAppSettings();
  const settings = globalPartner || appSettings;

  if (settings) {
    setCookie('partnerId', String(settings?.partnerId), expiresIn);
    // Setting this to max chrome cookie age as this is being used for Moodle authentication
    // purposes, and does not impact auth whatsoever
    setCookie('partnerUrl', String(baseUrl), CHROME_COOKIE_MAX_AGE);
    if (settings.parentPartnerId) {
      setCookie('parentPartnerId', String(settings.parentPartnerId), expiresIn);
    } else {
      deleteCookie('parentPartnerId');
    }
  }

  // We might want this to be more descriptive in the future? e.g. "Noodle", "Open" and "Private"?
  setCookie(
    'is_private_label',
    isNonNoodleInstance.toString(),
    new Date().getTime() + expiresIn * 1000,
  );
};

export const setSession = (authResult: AuthResult | any) => {
  setPrivateInstanceCookies(authResult.expiresIn);

  // Set the time that the Access Token will expire at
  const expiredTime = new Date().getTime() + authResult.expiresIn * 1000;

  setCookie('access_token', authResult.accessToken, authResult.expiresIn);
  setCookie('expires_at', String(authResult.expiresIn), authResult.expiresIn);
  setCookie('expired_time', String(expiredTime), authResult.expiresIn);
};
